// extracted by mini-css-extract-plugin
export var avatarContainer = "_7y-0";
export var avatarTypingWave = "_7y-i";
export var gray = "_7y-f";
export var green = "_7y-c";
export var icon = "_7y-9";
export var image = "_7y-1";
export var lg = "_7y-6";
export var md = "_7y-5";
export var presenceDot = "_7y-b";
export var red = "_7y-d";
export var sm = "_7y-4";
export var status = "_7y-a";
export var typingDot = "_7y-h";
export var typingPill = "_7y-g";
export var xl = "_7y-7";
export var xs = "_7y-3";
export var xxl = "_7y-8";
export var xxs = "_7y-2";
export var yellow = "_7y-e";